<template>
  <div>
    <Loading v-if="parameterLoading" />
    <div v-else class="p-box">
      <div class="p-box__body">
        <Info>
          {{ info }}
        </Info>

        <div class="p-table__content">
          <table>
            <thead>
              <tr>
                <th>
                  <span>{{ $t("models.parameter.name") }}</span>
                </th>
                <th />
              </tr>
              <tr class="p-table__content__space"><td colspan="5" /></tr>
            </thead>
            <tbody>
              <tr v-for="parameter in parameters" :key="parameter.id">
                <td class="u-fwB">{{ parameter.name }}</td>
                <td>
                  <div class="flexContainer">
                    <router-link :to="{ name: 'CompaniesParameterEdit', params: { company_uuid: currentCompanyUuid, parameter_id: parameter.id }}" class="action">
                      <Icon name="iconPencil" class="action__icon" />
                      {{ $t('labels.edit') }}
                    </router-link>
                    <a class="action" @click="onClickDelete(parameter.id)">
                      <Icon name="iconCross" class="action__icon" />
                      {{ $t('labels.delete') }}
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesParameterNew', params: { company_uuid: currentCompanyUuid } }" class="c-button__item c-button__item--primary">
            {{ $t('labels.add', { value: $t('models.parameter.modelName') }) }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Info from '../../../components/Info'
import Loading from '../../../components/Loading'
import Icon from '../../../components/Icon'

export default {
  name: 'CompaniesManagementParameters',
  components: {
    Info,
    Loading,
    Icon
  },
  computed: {
    ...mapState({
      parameterLoading: state => state.companiesParameters.loading,
      parameters: state => state.companiesParameters.data,
    }),
    ...mapGetters({
      isDocomoPlan: 'companiesCompany/isDocomoPlan',
    }),
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    info() {
      return this.isDocomoPlan
        ? this.$t('pages.companies.management.parameters.infoExceptGoogle', { beforeURL: 'https://example.com/{EXAMPLE}' })
        : this.$t('pages.companies.management.parameters.info', { beforeURL: 'https://example.com/{EXAMPLE}' })
    }
  },
  created() {
    this.readParameters()
  },
  methods: {
    ...mapActions({
      readParameters: 'companiesParameters/readParameters',
      deleteParameter: 'companiesParameter/deleteParameter'
    }),
    async onClickDelete(id) {
      if (confirm(this.$t('pages.companies.management.parameters.confirmToDelete'))) {
        const isSuccess = await this.deleteParameter(id)

        if(!isSuccess) return

        this.readParameters()
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.flexContainer {
  display: flex;
  justify-content: flex-end;
}
.action {
  display: flex;
  align-items: flex-start;
  margin-right: 24px;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
  &__icon {
    width: 18px;
    margin-right: 8px;
    img {
      display: block;
      width: 100%;
    }
  }
}
.p-table__content tbody th:not(:first-child), .p-table__content tbody td:not(:first-child) {
  border-left: none;
}
</style>
